export { User } from './user.model';
export { RequestSessionToken, SessionToken } from './session';

export enum AUTH_VERSION {
  VERSION_1 = '1',
  VERSION_2 = '2',
}

export interface MenuItem {
  name: string;
  icon: string;
  path: string;
  sub_menu?: any;
  children?: MenuItem[];
  isExpanded?: boolean;
}

export interface Service {
  title: string;
  text: string;
  icon: string;
  value: string;
  url?: string;
}

export interface ServiceSection {
  title: string;
  text: string;
  services: Service[];
}

export interface ISelectOption {
  title: string;
  subTitle: string;
  icon?: string;
  value: any;
  disabled?: boolean;
}

export interface IUploadDocument {
  title: string;
  subTitle: string;
  file?: string; // base64
}

export enum STORAGE_KEYS {
  CIF_RESPONSE = 'cif',
  CONTEXT_DATA = 'context',
  SUBJECT = 'subject',
  TICKET_RESPONSE = 'ticket',
}
